// Import Services
import RecipeService from "../services/RecipeService";

// Import models
import { Tag } from "@/models/tag.model";

const actions = {
  async fetchRecipes({ state, commit }: any, payload: any) {
    const params = {
      pagesize: payload?.pageSize || state.searchParams.pagesize,
      page: payload?.page || state.searchParams.page,
      search: state.searchParams.search,
      tags: payload?.tags || state.searchParams.tags.map((t: any) => t.id),
    };

    try {
      const response = await RecipeService.getAllRecipes(params);
      payload?.append
        ? commit("APPEND_RECIPES", response)
        : commit("SET_RECIPES", response);
    } catch (error) {
      console.log(error);
    }
  },
  async fetchSingleRecipe({ state, commit }: any, id: string) {
    try {
      const response = await RecipeService.getSingleRecipe(id);
      commit("SET_SINGLE_RECIPE", response);
    } catch (error) {
      console.log(error);
    }
  },
  async fetchGroups({ commit }: any) {
    try {
      const response = await RecipeService.getAllGroups();
      commit("SET_GROUPS", response);
    } catch (error) {
      console.log(error);
    }
  },
  async fetchSlides({ state, commit }: any) {
    const response: any = await RecipeService.getRecipeSlides();
    commit("SET_SLIDES", response);
  },
  setTags({ commit, dispatch }: any, tags: [] = []) {
    commit("RESET_PAGE");
    commit("SET_TAGS", tags);
    dispatch("fetchRecipes");
  },
  removeTag({ commit, dispatch }: any, tag: Tag) {
    commit("REMOVE_TAG", tag);
    dispatch("setTags");
  },
  updateSearchValue({ commit, dispatch }: any, searchValue: string) {
    commit("SET_SEARCH", searchValue === "" ? null : searchValue);
    dispatch("fetchRecipes");
  },
  resetTags({ commit }: any) {
    commit("RESET_TAGS");
  },
  async loadCollection({ commit, dispatch }: any, tags: [] = []) {
    commit("RESET_PAGE");
    commit("SET_SEARCH", null);
    dispatch("resetTags");
    commit("SET_TAGS", tags);
    await dispatch("fetchRecipes");
  },
  loadMore({ commit, dispatch }: any) {
    commit("LOAD_MORE");
    dispatch("fetchRecipes", { append: true });
  },
  removeLoader({ commit }: any) {
    commit("REMOVE_LOADER");
  },
  addLoader({ commit }: any) {
    commit("ADD_LOADER");
  },
};

export default actions;
